// extracted by mini-css-extract-plugin
export default {"item_wrap":"resources_item_wrap__7Y7IN","item_title":"resources_item_title__uy+S4","item_label":"resources_item_label__m0ewv","desc":"resources_desc__g-B86"};